$(document).ready(function () {
  if (window.location.href.includes('policy') || window.location.href.includes('terms-of-service') || window.location.href.indexOf("wishlist") > -1) {
    $("body").addClass("policy");
    // Add class to sticky-header under body.policy
    $("body.policy sticky-header").removeClass('color-scheme-2').addClass("color-scheme-1");
  }

  $('.js-footer-toggle').on('click', function (){
    $(this).next('.footer-menu__content').slideToggle(500);
    $(this).toggleClass('is-open');
  });

  $('.accordion--wrapper').on('click', function (){
    $(this).parent().prev().toggleClass('up');
    $(this).parent().next().toggleClass('down');
    $(this).parent().toggleClass('open');
    $(this).find('.accordion--content').slideToggle(500);
  });

  $('.menu-drawer__tab').on('click', function () {

    var tab = $(this).data('menu-tab');
    var panel = $('.menu-drawer__tab-panel[data-menu-panel="' + tab + '"]');

    // if already active, do nothing
    if ($(this).hasClass('active')) return;

    // switch tab highlight
    $('.menu-drawer__tab').removeClass('active');
    $(this).addClass('active');

    // slide current panel up
    $('.menu-drawer__tab-panel.active')
      .removeClass('active')
      .slideUp(200);

    // slide new panel down
    panel
      .addClass('active')
      .slideDown(200);

  });

  $('.menu-drawer__submenu-column .svg-wrapper').on('click', function (e) {

    e.preventDefault();

    var column = $(this).closest('.menu-drawer__submenu-column');
    var submenu = column.find('.menu-drawer__submenu-list');

    submenu.stop(true, true).slideToggle(200);

    column.toggleClass('open');

  });

  const $modal = $('#sizeGuideModal');
  const $closeBtn = $('#sizeGuideClose');

  // Open modal
  $('.product__size-guide').on('click', function () {
    $modal.addClass('active');
    $('body').css('overflow', 'hidden');
  });

  // Close via button
  $closeBtn.on('click', function () {
    $modal.removeClass('active');
    $('body').css('overflow', '');
  });

  // Close on overlay click
  $modal.on('click', function (e) {
    if ($(e.target).is('#sizeGuideModal')) {
      $modal.removeClass('active');
      $('body').css('overflow', '');
    }
  });

  // Slider Progress
  $('slider-component').each(function () {
    var $component = $(this);
    var $slider = $component.find('[id^="Slider-"]');
    var $slides = $slider.find('.slider__slide');
    var $progress = $component.find('.slider-progress');
    var $fill = $component.find('.slider-progress-fill');

    if (!$slider.length || !$slides.length || !$progress.length || !$fill.length) return;

    var total = $slides.length;

    function getVisibleIndex() {
      var slider = $slider[0];
      var sliderLeft = slider.scrollLeft;
      var sliderRight = sliderLeft + $slider.outerWidth();
      var maxScrollLeft = slider.scrollWidth - slider.clientWidth;

      // ✅ Fix: detect last slide
      if (sliderLeft >= maxScrollLeft - 2) {
        return total - 1;
      }

      var visibleIndex = 0;

      $slides.each(function (i) {
        var el = this;
        var elLeft = el.offsetLeft;
        var elRight = elLeft + el.offsetWidth;

        var isVisible =
          elRight > sliderLeft + 10 &&
          elLeft < sliderRight - 10;

        if (isVisible) {
          visibleIndex = i;
          return false; // break loop
        }
      });

      return visibleIndex;
    }

    function updateUI(index) {
      // ✅ update data attribute
      $progress.attr('data-slide', index + 1);

      // ✅ move indicator instead of fill
      var percent = (index / total) * 100;

      $fill.css({
        left: percent + '%'
      });
    }

    // ✅ initial state
    updateUI(0);

    var timeout;

    $slider.on('scroll', function () {
      clearTimeout(timeout);

      timeout = setTimeout(function () {
        var index = getVisibleIndex();
        updateUI(index);
      }, 60);
    });

    // ✅ update on resize
    $(window).on('resize', function () {
      var index = getVisibleIndex();
      updateUI(index);
    });
  });

  // Display file name when file is uploaded
  $('#Consignment-photo-upload, #Find-photo-upload').on('change', function() {
    if (this.files && this.files.length > 0) {
        var fileName = this.files[0].name;
        $('.upload-field__name').text(fileName);
    }
  });

  $("#Consignment-photo-upload").on("change", function () {
    const file = this.files[0];

    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "consignment");

    $.ajax({
      url: "https://api.cloudinary.com/v1_1/dycjc3bin/image/upload",
      type: "POST",
      data: formData,
      contentType: false,
      processData: false,
      success: function (response) {
        $("#uploadStatus").text("Upload complete.");

        // Store image URL in hidden input (sent with Shopify email)
        $("#imageUrl").val(response.secure_url);
      },
      error: function () {
       console.log('Upload failed');
      }
    });
  });

  $("#Find-photo-upload").on("change", function () {
    const file = this.files[0];

    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "find_for_me");

    $.ajax({
      url: "https://api.cloudinary.com/v1_1/dycjc3bin/image/upload",
      type: "POST",
      data: formData,
      contentType: false,
      processData: false,
      success: function (response) {
        $("#uploadStatus").text("Upload complete.");

        // Store image URL in hidden input (sent with Shopify email)
        $("#imageUrl").val(response.secure_url);
      },
      error: function () {
       console.log('Upload failed');
      }
    });
  });

  var $slider = $('.image-with-text__slider');

  if ($slider.length) {
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      arrows: true,
      dots: true,
      adaptiveHeight: true,
      swipe: true,
      draggable: true,
      speed: 500,
      cssEase: 'ease',
      prevArrow: '<svg class="slick-prev" width="30px" height="30px" viewBox="-5 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"><g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-421.000000, -1195.000000)" fill="#000000"><path d="M423.429,1206.98 L434.686,1196.7 C435.079,1196.31 435.079,1195.67 434.686,1195.28 C434.293,1194.89 433.655,1194.89 433.263,1195.28 L421.282,1206.22 C421.073,1206.43 420.983,1206.71 420.998,1206.98 C420.983,1207.26 421.073,1207.54 421.282,1207.75 L433.263,1218.69 C433.655,1219.08 434.293,1219.08 434.686,1218.69 C435.079,1218.29 435.079,1217.66 434.686,1217.27 L423.429,1206.98" id="chevron-left" sketch:type="MSShapeGroup"></path></g></g></svg>',
      nextArrow: '<svg class="slick-next" width="30px" height="30px" viewBox="-5 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"><g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-473.000000, -1195.000000)" fill="#000000"><path d="M486.717,1206.22 L474.71,1195.28 C474.316,1194.89 473.678,1194.89 473.283,1195.28 C472.89,1195.67 472.89,1196.31 473.283,1196.7 L484.566,1206.98 L473.283,1217.27 C472.89,1217.66 472.89,1218.29 473.283,1218.69 C473.678,1219.08 474.316,1219.08 474.71,1218.69 L486.717,1207.75 C486.927,1207.54 487.017,1207.26 487.003,1206.98 C487.017,1206.71 486.927,1206.43 486.717,1206.22" id="chevron-right" sketch:type="MSShapeGroup"></path></g></g></svg>',
      responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false // enable on tablet/mobile
        }
      }
    ]
    });
  }

  setTimeout( function(){
    $('.price__container').each(function () {
      var $container = $(this);

      var $sale = $container.find('.price__sale .ht-money');
      var $regular = $container.find('.price__regular .ht-money');

      var price = $sale.length ? $sale.text() : $regular.text();

      if (price) {
        price = String(price).replace('Dhs.', '').trim();

        $container.find('.price__hidden').text(price);
      }
    });
  }, 1000)
});